export const COLORS = {
  primary: "#1F79B4",
  white: "#ffffff",
  black: "#000000",
};
